// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202608310104/js/" + chunkId + "." + {"44":"17e096a7","225":"6dc88c04","481":"4db17065","486":"a566540d","770":"e9c16a7e"}[chunkId] + ".0.5159394074882406.chunk.js";
};